import { render, staticRenderFns } from "./RmaDocuments.vue?vue&type=template&id=051b6a0c&scoped=true"
import script from "./RmaDocuments.vue?vue&type=script&lang=js"
export * from "./RmaDocuments.vue?vue&type=script&lang=js"
import style0 from "./RmaDocuments.vue?vue&type=style&index=0&id=051b6a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051b6a0c",
  null
  
)

export default component.exports